import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { money } from "../lib/api";

export const ProductCard = ({ product: p, index = 0 }) => {
  const img = p.featuredImage?.url;
  const hoverImg = p.images?.[1]?.url;
  const price = p.priceRange?.minVariantPrice;
  const compare = p.compareAtPrice;
  const onSale =
    compare && price && parseFloat(compare.amount) > parseFloat(price.amount);
  const soldOut =
    p.variants?.length > 0 && p.variants.every((v) => !v.availableForSale);

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: index * 0.06, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/product/${p.handle}`}
        data-testid={`product-card-${p.handle}`}
        className="group block border border-border bg-card transition-colors duration-300 hover:border-signal/60"
      >
        <div className="relative aspect-[4/5] overflow-hidden bg-secondary">
          {img ? (
            <>
              <img
                src={img}
                alt={p.title}
                loading="lazy"
                className={`h-full w-full scale-[1.35] object-cover transition-all duration-700 group-hover:scale-150 ${
                  hoverImg ? "group-hover:opacity-0" : ""
                }`}
              />
              {hoverImg && (
                <img
                  src={hoverImg}
                  alt=""
                  loading="lazy"
                  className="absolute inset-0 h-full w-full scale-[1.35] object-cover opacity-0 transition-all duration-700 group-hover:scale-150 group-hover:opacity-100"
                />
              )}
            </>
          ) : (
            <div className="flex h-full items-center justify-center font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
              No image
            </div>
          )}
          <div className="absolute left-3 top-3 flex flex-col gap-1.5">
            {soldOut && (
              <span className="bg-foreground px-2 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.15em] text-background">
                Sold out
              </span>
            )}
            {onSale && !soldOut && (
              <span className="bg-signal px-2 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.15em] text-white">
                Sale
              </span>
            )}
          </div>
        </div>
        <div className="flex items-start justify-between gap-3 p-4">
          <div className="min-w-0">
            <h3 className="truncate font-display text-sm font-semibold uppercase tracking-wide">
              {p.title}
            </h3>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              {p.productType || "TRAILNONE"}
            </p>
          </div>
          <div className="shrink-0 text-right font-mono text-sm">
            {onSale && (
              <span className="mr-2 text-xs text-muted-foreground line-through">
                {money(compare)}
              </span>
            )}
            <span className={onSale ? "text-signal" : ""}>{money(price)}</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
